import classnames from 'classnames';
import type { HTMLInputTypeAttribute } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

import Tooltip from '../overlays/Tooltip';

interface FormTextInputProps {
    id: string;
    label: string;
    registration: UseFormRegisterReturn;
    error?: string;
    mandatory?: boolean;
    placeholder?: string;
    type?: HTMLInputTypeAttribute;
    maxLength?: number;
    disabled?: boolean;
    autoComplete?: string;
    className?: string;
}

const FormTextInput = ({
    id,
    label,
    registration,
    error,
    mandatory = false,
    placeholder,
    type = 'text',
    maxLength,
    disabled,
    autoComplete,
    className,
}: FormTextInputProps) => {
    const errorId = `${id}-error`;
    const { name, onChange, onBlur, ref } = registration;

    return (
        <div className={classnames('form-group mb-0', { 'has-error has-feedback': error })}>
            <label htmlFor={id}>
                {mandatory ? (
                    <>
                        <Tooltip trigger={<span>{label}</span>} placement='top-start' variant='plain'>
                            <p>Mandatory field</p>
                        </Tooltip>
                        <span className='text-color-danger' aria-hidden='true'>
                            *
                        </span>
                    </>
                ) : (
                    label
                )}
            </label>
            <input
                id={id}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                ref={ref}
                className={classnames('form-control', className)}
                placeholder={placeholder}
                type={type}
                maxLength={maxLength}
                disabled={disabled}
                autoComplete={autoComplete}
                required={false}
                aria-required={mandatory || undefined}
                aria-invalid={!!error}
                aria-describedby={error ? errorId : undefined}
            />
            {error && (
                <>
                    <span className='form-control-feedback rioglyph rioglyph-error-sign' aria-hidden='true' />
                    <span id={errorId} className='help-block'>
                        {error}
                    </span>
                </>
            )}
        </div>
    );
};

export default FormTextInput;
